import { render, staticRenderFns } from "./edit-payment-form.vue?vue&type=template&id=08520e72&scoped=true"
import script from "./edit-payment-form.vue?vue&type=script&lang=ts"
export * from "./edit-payment-form.vue?vue&type=script&lang=ts"
import style0 from "./edit-payment-form.vue?vue&type=style&index=0&id=08520e72&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08520e72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08520e72')) {
      api.createRecord('08520e72', component.options)
    } else {
      api.reload('08520e72', component.options)
    }
    module.hot.accept("./edit-payment-form.vue?vue&type=template&id=08520e72&scoped=true", function () {
      api.rerender('08520e72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/payment-edit-form/edit-payment-form.vue"
export default component.exports